import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
    createSupplier,
    updateSupplier,
} from "../../../slices/company/supplierSlice";
import Modal from "../../../components/modal";
import { API_URL } from "../../../utils/constant";

const AddEditSupplier = ({ show, onClose, supplierData }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    // const supplierData = location.state?.supplierData; // Get the supplier data from location state if editing

    // Form state initialization
    const [formValues, setFormValues] = useState({
        name: "",
        company_type: "",
        legal_name: "",
        email: "",
        mobile_no: "",
        gst_category: "Registered",
        tax_number: "",
        pan_number: "",
        pan_image: null,
        gst_image: null,
        cin: "",
        registration_date: "",
        gst_suspended: false,
        tds_on_gst_applicable: false,
        tds_applicable: false,
        gst_charge_for_party: false,
        ismsme: 0,
        msme_number: "",
        bank_name: "",
        bank_account_number: "",
        bank_ifsc_code: "",
        bank_branch: "",
        upi_id: "",
        billing_name: "",
        billing_email: "",
        billing_phone: "",
        billing_address: "",
        billing_city: "",
        billing_state: "",
        billing_country: "",
        billing_zipcode: "",
        shipping_name: "",
        shipping_email: "",
        shipping_phone: "",
        shipping_address: "",
        shipping_city: "",
        shipping_state: "",
        shipping_country: "",
        shipping_zipcode: "",

        website: "",
        facebook: "",
        skype: "",
        twitter: "",
        linkedin: "",
        credit_limit: "",
        max_credit_day: "",
        msme_category: "",
        msme_trade_service: ""
    });

    const [formError, setFormError] = useState({
        name: "",
        email: "",
        mobile_no: "",
        tax_number: "",
        pan_number: "",
    });

    const [error, setError] = useState(""); // For error handling

    useEffect(() => {
        // Reset the form if supplierData changes
        if (supplierData) {
            setFormValues({
                name: supplierData.name || "",
                company_type: supplierData.company_type || "",
                legal_name: supplierData.legal_name || "",
                email: supplierData.email || "",
                mobile_no: supplierData.mobile_no || "",
                tax_number: supplierData.tax_number || "",
                pan_number: supplierData.pan_number || "",
                gst_category: supplierData.gst_category || "Registered",
                cin: supplierData.cin || "",
                registration_date: supplierData.registration_date || "",
                gst_suspended: supplierData.gst_suspended || false,
                tds_on_gst_applicable: supplierData.tds_on_gst_applicable || false,
                tds_applicable: supplierData.tds_applicable || false,
                gst_charge_for_party: supplierData.gst_charge_for_party || false,
                ismsme: supplierData.ismsme || 0,
                msme_number: supplierData.msme_number || "",
                bank_name: supplierData.bank_name || "",
                bank_account_number: supplierData.bank_account_number || "",
                bank_ifsc_code: supplierData.bank_ifsc_code || "",
                bank_branch: supplierData.bank_branch || "",
                upi_id: supplierData.upi_id || "",
                billing_name: supplierData.billing_name || "",
                billing_phone: supplierData.billing_phone || "",
                billing_address: supplierData.billing_address || "",
                billing_city: supplierData.billing_city || "",
                billing_state: supplierData.billing_state || "",
                billing_country: supplierData.billing_country || "",
                billing_zipcode: supplierData.billing_zipcode || "",
                shipping_name: supplierData.shipping_name || "",
                shipping_phone: supplierData.shipping_phone || "",
                shipping_address: supplierData.shipping_address || "",
                shipping_city: supplierData.shipping_city || "",
                shipping_state: supplierData.shipping_state || "",
                shipping_country: supplierData.shipping_country || "",
                shipping_zipcode: supplierData.shipping_zipcode || "",

                website: supplierData.website || "",
                facebook: supplierData.facebook || "",
                skype: supplierData.skype || "",
                twitter: supplierData.skype || "",
                linkedin: supplierData.linkedin || "",
                credit_limit: supplierData.credit_limit || "",
                max_credit_day: supplierData.max_credit_day || "",
                msme_category: supplierData.msme_category || "",
                msme_trade_service: supplierData.msme_trade_service || "",
                gst_category: supplierData.gst_category || "Registered",
                cin: supplierData.cin || "",
                registration_date: supplierData.registration_date || "",
                gst_suspended: supplierData.gst_suspended || false,
                tds_on_gst_applicable: supplierData.tds_on_gst_applicable || false,
                tds_applicable: supplierData.tds_applicable || false,
                gst_charge_for_party: supplierData.gst_charge_for_party || false
            });
        }
    }, [supplierData]);

    const handleSameBilling = () => {
        setFormValues((prevFormData) => ({
            ...prevFormData,
            shipping_name: formValues.billing_name,
            shipping_email: formValues.billing_email,
            shipping_phone: formValues.billing_phone,
            shipping_address: formValues.billing_address,
            shipping_city: formValues.billing_city,
            shipping_state: formValues.billing_state,
            shipping_country: formValues.billing_country,
            shipping_zipcode: formValues.billing_zipcode, // Copy billingAddress to shippingAddress
        }));
    };

    // Handle input changes
    const handleInputChange = (e) => {
        const { name, value, type, files, checked } = e.target;

        let updatedValue = value;
        if (type === "checkbox") {
            updatedValue = checked ? 1 : 0; // Store checkbox as 1 or 0
        } else if (type === "file") {
            updatedValue = files[0]; // Store the selected file
        } else {
            updatedValue = value; // Remove spaces for text inputs
        }

        // ✅ Automatically capitalize PAN number and validate format
        if (name === "pan_number") {
            updatedValue = updatedValue.toUpperCase();

            const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/; // PAN format: AAAAA1234A
            setFormError((prevState) => ({
                ...prevState,
                [name]: updatedValue && !panRegex.test(updatedValue) ? "Please enter a valid PAN Number" : "",
            }));
        }

        // ✅ Validate Mobile Number (Indian format: 10 digits, starts with 6-9)
        // if (name === "mobile_no") {
        //     const mobileRegex = /^[6-9]\d{9}$/;
        //     setFormError((prevState) => ({
        //         ...prevState,
        //         [name]: updatedValue && !mobileRegex.test(updatedValue) ? "Please enter a valid 10-digit mobile number" : "",
        //     }));
        // }

        // ✅ Update Form State
        setFormValues((prevState) => ({
            ...prevState,
            [name]: updatedValue,
        }));
    };

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();

        // Validation
        if (!formValues.name || !formValues.email || !formValues.mobile_no) {
            setError("Please fill in all required fields.");
            return;
        }

        // Validate mobile number (should be 10 digits starting from 6-9)
        // const mobileRegex = /^[6-9]\d{9}$/;
        // if (!mobileRegex.test(formValues.mobile_no)) {
        //     setFormError((prevState) => ({
        //         ...prevState,
        //         ['mobile_no']: "Please enter a valid 10-digit mobile number.",
        //     }));
        //     return;
        // }

        // Get company_id from localStorage
        const company = JSON.parse(localStorage.getItem("company"));

        if (!company) {
            setError("Company ID is missing. Please log in again.");
            return;
        }

        // Append company_id to formValues

        const formData = { ...formValues, company_id: company.company?.id };
        // Dispatch add or update action based on the presence of supplierData
        if (supplierData?.id) {
            // Update supplier if ID exists
            dispatch(updateSupplier({ supplierData: formData, id: supplierData.id }));
        } else {
            dispatch(createSupplier(formData));
        }
        setFormValues((prevState) => ({
            ...prevState,
            pan_image: null, // Reset file input state
        }));
        onClose();
        // After submission, navigate back to the supplier list or wherever needed
        // navigate("/suppliers"); // Adjust the path as necessary
    };

    return (
        <Modal
            show={show}
            onClose={onClose}
            heading={supplierData?.id ? "Edit Supplier" : "Add Supplier"}
        >
            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-md-12">
                        <h3 className="mb-3">Basic Information</h3>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>Firm Name / Trade Name</label>
                            <input
                                type="text"
                                name="name"
                                className="form-control"
                                value={formValues.name}
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>Firm Email</label>
                            <input
                                type="email"
                                name="email"
                                className="form-control"
                                value={formValues.email}
                                onChange={handleInputChange}
                                required
                            />

                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>Mobile Number</label>
                            <input
                                type="text"
                                // maxLength={10}
                                name="mobile_no"
                                className="form-control"
                                value={formValues.mobile_no}
                                onChange={handleInputChange}
                                required
                            />
                            {formError.mobile_no && (
                                <span className="text-danger">{formError.mobile_no}</span>
                            )}
                        </div>
                    </div>


                    <div
                        className={`${supplierData && supplierData.pan_image ? "col-md-4" : "col-md-6"
                            }`}
                    >
                        <div className="form-group mb-4">
                            <label>Pan Card Image</label>
                            <input
                                type="file"
                                name="pan_image"
                                className="form-control"
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>
                    {supplierData && supplierData.pan_image && (
                        <div className="col-md-2">
                            <img
                                src={`${API_URL}/uploads/suppliers/${supplierData.pan_image}`}
                                alt="pan_image"
                                width={"auto"}
                                height={"80px"}
                            />
                        </div>
                    )}
                    <div className="col-md-6 mb-4">
                        <label>Company Type</label>
                        <select
                            data-tw-merge=""
                            value={formValues.company_type}
                            id="category"
                            name="company_type"
                            onChange={handleInputChange}
                            className="form-control"
                        >
                            <option value=""> -- Select Status --</option>
                            <option value="Individual">Individual</option>
                            <option value="* Public Limited Company">
                                Public Limited Company
                            </option>
                            <option value="Private Limited Company">
                                Private Limited Company
                            </option>
                            <option value="Partnerships">Partnerships</option>
                            <option value="LLP Registration">LLP Registration</option>
                            <option value="One Person Company">One Person Company</option>
                            <option value="Sole Proprietorship">Sole Proprietorship</option>
                            <option value="Section 8 Company">Section 8 Company</option>
                            <option value="Association of Persons (AOP) or Body of Individuals (BOI)">
                                Association of Persons (AOP) or Body of Individuals (BOI)
                            </option>
                            <option value="Local Authority">Local Authority</option>
                            <option value="Artificial Judicial Body (not covered under any of the above-mentioned categories)">
                                Artificial Judicial Body (not covered under any of the
                                above-mentioned categories)
                            </option>
                        </select>
                    </div>
                    {formValues.company_type == "Sole Proprietorship" && (
                        <div className="col-md-6">
                            <label>Legal Name</label>
                            <input
                                type="text"
                                name="legal_name"
                                value={formValues.legal_name}
                                className="form-control"
                                onChange={handleInputChange}
                            />
                        </div>
                    )}

                    <div className="col-md-12">
                        <h3 className="mt-3 mb-4">Statutory</h3>
                    </div>

                    {/* GST Category */}
                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>GST Category</label>
                            <select
                                name="gst_category"
                                className="form-control"
                                value={formValues.gst_category}
                                onChange={handleInputChange}
                            >
                                <option value="">Select</option>
                                <option value="Registered">Registered</option>
                                <option value="Unregistered">Unregistered</option>
                                <option value="Composition">Composition</option>
                                <option value="UIN_SEZ">UIN / SEZ</option>
                                <option value="ExportHouse">Export House</option>
                                <option value="OverseasParty">Overseas Party</option>
                            </select>
                        </div>
                    </div>

                    {/* GST Number (only if Registered / Composition / UIN_SEZ) */}
                    {["Registered", "Composition", "UIN_SEZ"].includes(formValues.gst_category) && (
                        <div className="col-md-6">
                            <div className="form-group mb-4">
                                <label>GST Number</label>
                                <input
                                    type="text"
                                    name="tax_number"
                                    className="form-control"
                                    value={formValues.tax_number}
                                    onChange={handleInputChange}
                                />
                            </div>
                        </div>
                    )}

                    {/* CIN */}
                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>CIN</label>
                            <input
                                type="text"
                                name="cin"
                                className="form-control"
                                value={formValues.cin}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>Pan Card Number</label>
                            <input
                                type="text"
                                name="pan_number"
                                className="form-control"
                                value={formValues.pan_number}
                                onChange={handleInputChange}
                            />
                            {formError.pan_number && (
                                <span className="text-danger">{formError.pan_number}</span>
                            )}
                        </div>
                    </div>

                    {/* Registration Date */}
                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>Registration Date</label>
                            <input
                                type="date"
                                name="registration_date"
                                className="form-control"
                                value={formValues.registration_date}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>Credit Limit</label>
                            <input
                                type="number"
                                name="credit_limit"
                                className="form-control"
                                value={formValues.credit_limit}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>Max Credit Days</label>
                            <input
                                type="number"
                                name="max_credit_day"
                                className="form-control"
                                value={formValues.max_credit_day}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>GST Document</label>
                            <input
                                type="file"
                                name="gst_image"
                                className="form-control"
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>
                    <div className="col-md-12 d-flex align-items-center">
                        <div className="form-check mt-3  mb-3">
                            <input
                                type="checkbox"
                                className="form-check-input"
                                name="gst_suspended"
                                checked={formValues.gst_suspended}
                                onChange={handleInputChange}
                            />
                            <label className="form-check-label">GST Suspended</label>
                        </div>
                    </div>

                    {/* GST Document */}


                    {/* TDS on GST Applicable */}
                    <div className="col-md-12">
                        <div className="form-check mb-3">
                            <input
                                type="checkbox"
                                className="form-check-input"
                                name="tds_on_gst_applicable"
                                checked={formValues.tds_on_gst_applicable}
                                onChange={handleInputChange}
                            />
                            <label className="form-check-label">TDS on GST Applicable</label>
                        </div>
                    </div>

                    {/* TDS Applicable */}
                    <div className="col-md-12">
                        <div className="form-check mb-3">
                            <input
                                type="checkbox"
                                className="form-check-input"
                                name="tds_applicable"
                                checked={formValues.tds_applicable}
                                onChange={handleInputChange}
                            />
                            <label className="form-check-label">TDS Applicable</label>
                        </div>
                    </div>

                    {/* GST Charge for Party (Only for UIN / SEZ) */}
                    {formValues.gst_category === "UIN_SEZ" && (
                        <div className="col-md-12">
                            <div className="form-check mb-3">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    name="gst_charge_for_party"
                                    checked={formValues.gst_charge_for_party}
                                    onChange={handleInputChange}
                                />
                                <label className="form-check-label">
                                    GST Charge for Party
                                </label>
                            </div>
                        </div>
                    )}

                    {supplierData && supplierData.gst_image && (
                        <div className="col-md-4">
                            <div className="mt-4 pt-2">
                                <a href={`${API_URL}/uploads/suppliers/${supplierData.pan_image}`} target="_blank">Download Gst Document</a>
                            </div>

                        </div>
                    )}

                    <div className="col-md-12">
                        <div className="form-check mb-2">
                            <input type="checkbox" className="form-check-input" name="ismsme" onChange={handleInputChange} checked={!!formValues.ismsme} />
                            &nbsp;<label className="form-check-label">IS MSME Register</label>
                        </div>
                    </div>
                    {formValues.ismsme == 1 && (

                        <>
                            <div className="col-md-4">
                                <label>Category</label>
                                <select
                                    name="msme_category"
                                    className="form-control"
                                    value={formValues.msme_category}
                                    onChange={handleInputChange}
                                >
                                    <option value="">Select</option>
                                    <option value="Manufacturer">Manufacturer</option>
                                    <option value="Trader">Trader</option>
                                    <option value="Service Provider">Service Provider</option>
                                    <option value="Others">Others</option>
                                </select>
                            </div>
                            <div className="col-md-4">
                                <label>Trade Service</label>
                                <select
                                    name="msme_trade_service"
                                    className="form-control"
                                    value={formValues.msme_trade_service}
                                    onChange={handleInputChange}
                                >
                                    <option value="">Select</option>
                                    <option value="Manufacturer">Manufacturer</option>
                                    <option value="Trader">Trader</option>
                                    <option value="Service Provider">Service Provider</option>
                                    <option value="Others">Others</option>
                                </select>
                            </div>
                            

                            <div className="col-md-4">
                                <label>Uddyam Reg No</label>
                                <input
                                    type="text"
                                    name="msme_number"
                                    value={formValues.msme_number}
                                    className="form-control"
                                    onChange={handleInputChange}
                                />
                            </div>
                        </>
                    )}

                    <div className="col-md-12">
                        <h3 className="mt-3 mb-4">Social Profiles</h3>
                    </div>

                    {/* Website */}
                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>Website</label>
                            <input
                                type="url"
                                name="website"
                                className="form-control"
                                placeholder="https://example.com"
                                value={formValues.website}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>

                    {/* Facebook */}
                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>Facebook</label>
                            <input
                                type="url"
                                name="facebook"
                                className="form-control"
                                placeholder="https://facebook.com/username"
                                value={formValues.facebook}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>

                    {/* Skype */}
                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>Skype</label>
                            <input
                                type="text"
                                name="skype"
                                className="form-control"
                                placeholder="Skype ID"
                                value={formValues.skype}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>

                    {/* Twitter / X */}
                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>Twitter (X)</label>
                            <input
                                type="url"
                                name="twitter"
                                className="form-control"
                                placeholder="https://twitter.com/username"
                                value={formValues.twitter}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>

                    {/* LinkedIn */}
                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>LinkedIn</label>
                            <input
                                type="url"
                                name="linkedin"
                                className="form-control"
                                placeholder="https://linkedin.com/in/username"
                                value={formValues.linkedin}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>


                    <div className="col-md-12">
                        <h3 className="mt-4 mb-5">Bank & Payment Details</h3>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>Bank Name</label>
                            <input type="text"
                                name="bank_name"
                                className="form-control"
                                value={formValues.bank_name}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>Bank Account Number</label>
                            <input
                                type="text"
                                name="bank_account_number"
                                className="form-control"
                                value={formValues.bank_account_number}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>Bank IFSC Code</label>
                            <input
                                type="text"
                                name="bank_ifsc_code"
                                className="form-control"
                                value={formValues.bank_ifsc_code}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>Bank Branch</label>
                            <input
                                type="text"
                                name="bank_branch"
                                className="form-control"
                                value={formValues.bank_branch}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>UPI ID</label>
                            <input
                                type="text"
                                name="upi_id"
                                className="form-control"
                                value={formValues.upi_id}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>

                    <div className="col-md-12">
                        <h3 className="mt-4 mb-5">Billing Address</h3>
                    </div>

                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>Name</label>
                            <input
                                type="text"
                                name="billing_name"
                                className="form-control"
                                value={formValues.billing_name}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>Email</label>
                            <input
                                type="text"
                                name="billing_email"
                                className="form-control"
                                value={formValues.billing_email}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>Phone</label>
                            <input
                                type="text"
                                name="billing_phone"
                                className="form-control"
                                value={formValues.billing_phone}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>City</label>
                            <input
                                type="text"
                                name="billing_city"
                                className="form-control"
                                value={formValues.billing_city}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>

                    <div className="col-md-4">
                        <div className="form-group mb-4">
                            <label>State</label>
                            <input
                                type="text"
                                name="billing_state"
                                className="form-control"
                                value={formValues.billing_state}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>

                    <div className="col-md-4">
                        <div className="form-group mb-4">
                            <label>Country</label>
                            <input
                                type="text"
                                name="billing_country"
                                className="form-control"
                                value={formValues.billing_country}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>

                    <div className="col-md-4">
                        <div className="form-group mb-4">
                            <label>Zipcode</label>
                            <input
                                type="text"
                                name="billing_zipcode"
                                className="form-control"
                                value={formValues.billing_zipcode}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="form-group mb-4">
                            <label>Address</label>
                            <textarea
                                type="text"
                                name="billing_address"
                                rows={3}
                                className="form-control"
                                value={formValues.billing_address}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>

                    <div className="col-md-12">
                        <h3 className="mt-4 mb-5">
                            Shipping Address
                            <span className="float-end">
                                <button
                                    type="button"
                                    onClick={() => handleSameBilling()}
                                    className="btn btn-primary"
                                >
                                    Same as Billing
                                </button>
                            </span>
                        </h3>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>Name</label>
                            <input
                                type="text"
                                name="shipping_name"
                                className="form-control"
                                value={formValues.shipping_name}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>Email</label>
                            <input
                                type="text"
                                name="shipping_email"
                                className="form-control"
                                value={formValues.shipping_email}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>Phone</label>
                            <input
                                type="text"
                                name="shipping_phone"
                                className="form-control"
                                value={formValues.shipping_phone}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>City</label>
                            <input
                                type="text"
                                name="shipping_city"
                                className="form-control"
                                value={formValues.shipping_city}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>

                    <div className="col-md-4">
                        <div className="form-group mb-4">
                            <label>State</label>
                            <input
                                type="text"
                                name="shipping_state"
                                className="form-control"
                                value={formValues.shipping_state}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>

                    <div className="col-md-4">
                        <div className="form-group mb-4">
                            <label>Country</label>
                            <input
                                type="text"
                                name="shipping_country"
                                className="form-control"
                                value={formValues.shipping_country}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>

                    <div className="col-md-4">
                        <div className="form-group mb-4">
                            <label>Zipcode</label>
                            <input
                                type="text"
                                name="shipping_zipcode"
                                className="form-control"
                                value={formValues.shipping_zipcode}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="form-group mb-4">
                            <label>Address</label>
                            <textarea
                                type="text"
                                name="shipping_address"
                                rows={3}
                                className="form-control"
                                value={formValues.shipping_address}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>

                    {error && (
                        <div className="col-md-12">
                            <p className="text-danger">{error}</p>
                        </div>
                    )}

                    <div className="col-md-6">
                        <button type="submit" className="btn btn-primary btn-block">
                            {supplierData?.id ? "Update" : "Submit"}
                        </button>
                    </div>
                </div>
            </form>
        </Modal>
    );
};

export default AddEditSupplier;
